/* @flow */

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  button: {
    backgroundColor: 'transparent',
    width: 42,
    height: 42,
    padding: 0,
    position: 'relative',

    '& svg': {
      color: ({ theme }: ThemeFunction) => theme.textColor,
      marginTop: '3px !important',
    },

    '&:focus': {
      outline: 'none',

      '&:after': {
        position: 'absolute',
        content: '""',
        top: 9,
        left: 9,
        width: 24,
        height: 24,
        border: ({ theme }: ThemeFunction) => `1px solid ${theme.accentColor}`,
        borderRadius: '50%',
      },
    },
  },
  menuItem: {
    color: ({ theme }: ThemeFunction) => `${theme.textColor} !important`,
  },
};
